import { LayoutExternoComponent } from './components/layout-externo/layout-externo.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { AuthService } from './servicios/auth.service';
import { PaginaNoEncontrada404Component } from './components/shared/pagina-no-encontrada404/pagina-no-encontrada404.component';


const routes: Routes = [
  { path: '', redirectTo: '/inicio', pathMatch: 'full' },
  {
    path: 'inicio',
    loadChildren: () => import('./components/Auth/auth.module').then(m => m.AuthModule)
  },
  {
    path: 'componente', component: LayoutExternoComponent,
    loadChildren: () => import('./components/layout-externo/layout-externo.module').then(m => m.LayoutExternoModule)
  },
  {
    path: 'sistema',
    canActivate: [AuthService],
    loadChildren: () => import('./components/sistema/sistema.module').then(m => m.SistemaModule)
  },
  { path: '**', component: PaginaNoEncontrada404Component }
];

@NgModule({
  imports: [RouterModule.forRoot(routes,
    {
      preloadingStrategy: PreloadAllModules,
      useHash: true,
      scrollPositionRestoration: 'top'
    },
  ),
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
